import { Validator } from 'vee-validate'
import moment from 'moment'

Validator.extend('isNationality', {
  getMessage: field => 'The ' + field + ' value is incorrect.',
  validate: (value, countries) => {
    if (value) {
      return !!countries.find(c => c.nationality === value)
    }
    return false
  }
})

Validator.extend('isNationalityNotAvailable', {
  getMessage: (field, params, data) => {
    return `Nationality ${data} (not available)`
  },
  validate: (value, countries) => {
    let isValid = false
    const expectedCountry = countries.find(c => c.nationality.toLowerCase() === value.toLowerCase())
    if (expectedCountry && (!expectedCountry.hasOwnProperty('disabled') || (expectedCountry.hasOwnProperty('disabled') && !expectedCountry.disabled))) {
      isValid = true
    }
    return {
      valid: isValid,
      data: value
    }
  }
})

Validator.extend('ageMoreThanTwenty', {
  getMessage: () => 'Age must more than 20 years old.',
  validate: value => {
    if (value) {
      return moment().diff(value, 'years') >= 20
    }
    return false
  }
})

Validator.extend('isThaiIdCard', {
  getMessage: () => 'The ID Card number is incorrect.',
  validate: id => {
    if (id.length !== 13) return false
    let sum = 0
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i)
    }
    if ((11 - sum % 11) % 10 !== parseFloat(id.charAt(12))) {
      return false
    }
    return true
  }
})

Validator.extend('isLaserCode', {
  getMessage: () => 'The laser code is incorrect.',
  validate: code => {
    if (code) {
      const regex = /^[A-Za-z]{2}\d{1}[-]?\d{7}[-]?\d{2}$/
      return regex.test(code)
    }
    return false
  }
})

Validator.extend('dateBeforeNow', {
  getMessage: (field) => `The ${field} value must less than or equal now.`,
  validate: date => {
    if (date) {
      return moment(date).diff(moment(), 'day') <= 0
    }
    return false
  }
})

Validator.extend('dateAfterNow', {
  getMessage: (field) => `Your ${field} value is expired or will be expire in 7 days.`,
  validate: date => {
    if (date) {
      return moment(date).diff(moment(), 'day') >= 6
    }
    return false
  }
})



// WEBPACK FOOTER //
// ./src/utils/validator.js